import { render, staticRenderFns } from "./ProductPricePart.vue?vue&type=template&id=4bd05196&scoped=true&"
import script from "./ProductPricePart.vue?vue&type=script&lang=js&"
export * from "./ProductPricePart.vue?vue&type=script&lang=js&"
import style0 from "./ProductPricePart.vue?vue&type=style&index=0&id=4bd05196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd05196",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
